import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { config } from "./config";

const enableMocking = async (): Promise<void> => {
  if (!config.api.useMocks) {
    return;
  }

  const { worker } = await import("./mocks/browser");

  await worker.start({
    onUnhandledFrame: "bypass",
  });
};

export const main = async (): Promise<void> => {
  const requestedLegacyInterface = new URLSearchParams(
    window.location.search,
  ).get("legacy_interface");
  if (
    window.location.pathname === "/vbuyer/mm_requests" &&
    (requestedLegacyInterface === "true" ||
      requestedLegacyInterface === "false")
  ) {
    localStorage.setItem("legacy_interface", requestedLegacyInterface);
  }

  await enableMocking();

  const mountNode = document.getElementById("root");
  if (!mountNode) {
    throw new Error("Mount node not found");
  }

  const reactWithRails = JSON.parse(
    mountNode.getAttribute("data-prop-react-with-rails") ?? "false",
  ) as boolean;
  window.reactWithRails = !!reactWithRails;

  const root = createRoot(mountNode);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
};
